export const MONTHS = 'months';
export const MONTHS_WRAP = 'months-wrap';
export const MONTH_BUTTON = 'month-button';
